export default __webpack_public_path__ + "static/media/2-min.284c37c9.jpg";